/** Navigation section groupings for the floating shell */
export const NAV_SECTIONS = [
  {
    id: 'overview',
    label: 'Overview',
    entryIds: ['dashboard'],
  },
  {
    id: 'operations',
    label: 'Operations',
    entryIds: [
      'master-data',
      'catalog',
      'sales',
      'dispatch',
      'purchases',
      'tasks',
    ],
  },
  {
    id: 'management',
    label: 'Management',
    entryIds: ['reports', 'company', 'settings', 'user-management'],
  },
] as const
